import { render, staticRenderFns } from "./EditAccountForm.vue?vue&type=template&id=2b3257d8&scoped=true&v-if=form.id&"
import script from "./EditAccountForm.vue?vue&type=script&lang=js&"
export * from "./EditAccountForm.vue?vue&type=script&lang=js&"
import style0 from "./EditAccountForm.vue?vue&type=style&index=0&id=2b3257d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3257d8",
  null
  
)

export default component.exports